// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Profile{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    margin-top: auto;
    /* background-color: aqua; */
    position: relative;
}
.Community-Image{
    width: 100%;
    height: 100px;
    border-radius: 20px;
}

@media screen and (min-width: 375px) {
    .Community-Image{
        width: 98vw;
        height: 140px;
        border-radius: 20px;
        margin: auto;
    }
}

@media screen and (min-width: 992px) {
    .Community-Image{
        width: 98vw;
        height: 160px;
        border-radius: 20px;
        margin: auto;
    }
}

@media screen and (min-width: 1024px) {
    .Community-Image{
        width: 92vw;
        height: 180px;
        border-radius: 20px;
        margin: auto;
    }
}

@media screen and (min-width: 1200px) {
    .Community-Image{
        width: 80vw;
        height: 180px;
        border-radius: 20px;
        margin: auto;
    }
}

@media screen and (min-width: 1440px) {
    .Community-Image{
        width: 70vw;
        height: 180px;
        border-radius: 20px;
        margin: auto;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Modules/Activity/Profile/Profile.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,YAAY;IAChB;AACJ","sourcesContent":[".Profile{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: flex-start;\r\n    width: 100%;\r\n    height: 100%;\r\n    margin-top: auto;\r\n    /* background-color: aqua; */\r\n    position: relative;\r\n}\r\n.Community-Image{\r\n    width: 100%;\r\n    height: 100px;\r\n    border-radius: 20px;\r\n}\r\n\r\n@media screen and (min-width: 375px) {\r\n    .Community-Image{\r\n        width: 98vw;\r\n        height: 140px;\r\n        border-radius: 20px;\r\n        margin: auto;\r\n    }\r\n}\r\n\r\n@media screen and (min-width: 992px) {\r\n    .Community-Image{\r\n        width: 98vw;\r\n        height: 160px;\r\n        border-radius: 20px;\r\n        margin: auto;\r\n    }\r\n}\r\n\r\n@media screen and (min-width: 1024px) {\r\n    .Community-Image{\r\n        width: 92vw;\r\n        height: 180px;\r\n        border-radius: 20px;\r\n        margin: auto;\r\n    }\r\n}\r\n\r\n@media screen and (min-width: 1200px) {\r\n    .Community-Image{\r\n        width: 80vw;\r\n        height: 180px;\r\n        border-radius: 20px;\r\n        margin: auto;\r\n    }\r\n}\r\n\r\n@media screen and (min-width: 1440px) {\r\n    .Community-Image{\r\n        width: 70vw;\r\n        height: 180px;\r\n        border-radius: 20px;\r\n        margin: auto;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
